import {
  FILTER_TYPE_NAME_CATEGORY,
  VEHICLE_NAME_ALL_COMMERCIAL_VEHICLES,
  VEHICLE_NAME_ALL_PASSENGER_CARS,
  VEHICLE_NAME_ELECTRIC_CARS,
  VEHICLE_NAME_HATCHBACK,
  VEHICLE_NAME_HYBRID_CARS,
  VEHICLE_NAME_LUXURY_SEDAN,
  VEHICLE_NAME_MID_SIZED_SEDAN,
  VEHICLE_NAME_MPV,
  VEHICLE_NAME_SPORTS_CARS,
  VEHICLE_NAME_STATIONWAGON,
  VEHICLE_NAME_SUV,
  VEHICLE_VALUE_ALL_COMMERCIAL_VEHICLES,
  VEHICLE_VALUE_ALL_PASSENGER_CARS,
  VEHICLE_VALUE_ELECTRIC_CARS,
  VEHICLE_VALUE_HATCHBACK,
  VEHICLE_VALUE_HYBRID_CARS,
  VEHICLE_VALUE_LUXURY_SEDAN,
  VEHICLE_VALUE_MID_SIZED_SEDAN,
  VEHICLE_VALUE_MPV,
  VEHICLE_VALUE_SPORTS_CARS,
  VEHICLE_VALUE_STATIONWAGON,
  VEHICLE_VALUE_SUV,
} from '@/constants/global';

import type { SelectOption } from './types';

export const vehicleTypeSelectOptionConfigs: SelectOption = {
  placeholder: {
    text: 'Vehicle Type',
    isOptionHidden: true,
  },
  optionList: [
    { text: 'Any', value: '' },
    { text: VEHICLE_NAME_HYBRID_CARS, value: VEHICLE_VALUE_HYBRID_CARS },
    { text: VEHICLE_NAME_ELECTRIC_CARS, value: VEHICLE_VALUE_ELECTRIC_CARS },
    { text: VEHICLE_NAME_HATCHBACK, value: VEHICLE_VALUE_HATCHBACK },
    { text: VEHICLE_NAME_LUXURY_SEDAN, value: VEHICLE_VALUE_LUXURY_SEDAN },
    { text: VEHICLE_NAME_MPV, value: VEHICLE_VALUE_MPV },
    {
      text: VEHICLE_NAME_MID_SIZED_SEDAN,
      value: VEHICLE_VALUE_MID_SIZED_SEDAN,
    },
    { text: VEHICLE_NAME_SPORTS_CARS, value: VEHICLE_VALUE_SPORTS_CARS },
    { text: VEHICLE_NAME_STATIONWAGON, value: VEHICLE_VALUE_STATIONWAGON },
    { text: VEHICLE_NAME_SUV, value: VEHICLE_VALUE_SUV },
    {
      text: VEHICLE_NAME_ALL_COMMERCIAL_VEHICLES,
      value: VEHICLE_VALUE_ALL_COMMERCIAL_VEHICLES,
    },
    {
      text: VEHICLE_NAME_ALL_PASSENGER_CARS,
      value: VEHICLE_VALUE_ALL_PASSENGER_CARS,
    },
  ],
};

export const categorySelectOptionConfigs: SelectOption = {
  placeholder: {
    text: FILTER_TYPE_NAME_CATEGORY,
    isOptionHidden: true,
  },
  optionList: [
    { text: 'Any', value: '' },
    { text: 'Authorised Distributor', value: 'ad' },
    { text: 'Parallel Importer', value: 'pi' },
    { text: 'Cat A COE', value: 'a' },
    { text: 'Cat B COE', value: 'b' },
  ],
};
